import React, { useContext } from 'react';
import { OverviewComponentType, ProductOverviewRegistry } from '../../types';
import SummaryMetricsMesLite from 'containers/UserBehaviorEngagement/Manufacturing/SummaryMetricsMesLite';
import MESLiteValueCreationScoreCard from 'containers/ValueCreationMetrics/MESLiteValueCreation/MESLiteValueCreationScoreCard';
import UserInteractionSummary from 'containers/UserBehaviorEngagement/Manufacturing/UserInteractionSummary';
import AppPerformanceHOC from 'containers/OverView/B2BOverview/Highlights/AppPerformanceHOC';
import { FilterContext } from 'components/FilterBar/FilterProvider';
import { constants } from 'constants/Constants';

const AppPerformanceScorecard: React.FC = () => {
  const { selectedPlant } = useContext(FilterContext);

  // Hide AppPerformanceHOC for Celaya Salty plant
  if (selectedPlant?.id === constants.plants.celayaSalty) {
    return null;
  }

  return (
    <AppPerformanceHOC
      slug="app-performance"
      title="App Performance"
      isOverview={true}
    />
  );
};

const scorecards: OverviewComponentType[] = [
  () => (
    <MESLiteValueCreationScoreCard
      title={'Value Creation'}
      showInfoIcon={true}
    />
  ),
  AppPerformanceScorecard,
  () => <SummaryMetricsMesLite title="User Adoption - Standard Metrics" />,
  () => <UserInteractionSummary title="User Adoption - User Interaction" />,
];

const customOverview: OverviewComponentType | null = null;

const mesLiteRegistry: ProductOverviewRegistry = {
  scorecards,
  customOverview,
};

export default mesLiteRegistry;
